import { render, staticRenderFns } from "./ProfileSettingsChangePassword.vue?vue&type=template&id=0a76c74f&scoped=true&"
import script from "./ProfileSettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingsChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingsChangePassword.vue?vue&type=style&index=0&id=0a76c74f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a76c74f",
  null
  
)

export default component.exports